module.exports = __webpack_public_path__ + "static/media/muscular.9e2e4059.jpg";